import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index.js';
import '@/assets/css/element/index.css';
import '@/assets/css/common.css';
import '@/assets/font/iconfont.css';
import "viewerjs/dist/viewer.css";
import store from './store';
import * as filters from '@/assets/utils/filter.js'
import "swiper/dist/css/swiper.css";
import VueViewer from 'v-viewer';

// import '@/assets/css/element-variables.scss';
Vue.use(ElementUI);
Vue.use(VueViewer);
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

